// extracted by mini-css-extract-plugin
export default {"pageNation":"PageNation_pageNation__Z09Ip","active":"PageNation_active__agVQ4","disabled":"PageNation_disabled__Fm+-l"};